import { NSDataTypes } from './utils/data_types'
import { NSGeoJson } from './utils/geojson';


export const NSGeometryClipboard = {};

NSGeometryClipboard.init = function () {
    NSGeometryClipboardPrivate.init();

    this.f_add_geometry = function () { return NSGeometryClipboardPrivate.f_add_geometry.apply( NSGeometryClipboardPrivate, arguments ); };
    this.f_get_geometry = function () { return NSGeometryClipboardPrivate.f_get_geometry.apply( NSGeometryClipboardPrivate, arguments ); };
    this.f_get_geometry_as_geometry_of_type = function () { return NSGeometryClipboardPrivate.f_get_geometry_as_geometry_of_type.apply( NSGeometryClipboardPrivate, arguments ); };

    
    this.f_b_clipboard_geometry_exists_and_is_compatible_with_specified_db_geometry_type = function () { return NSGeometryClipboardPrivate.f_b_clipboard_geometry_exists_and_is_compatible_with_specified_db_geometry_type.apply( NSGeometryClipboardPrivate, arguments ); };
    
    
    
}

const NSGeometryClipboardPrivate = {
    
    o_geojson_feature_geometry: null,

    init: function()
    {

    },

    f_add_geometry: function(o_geojson_feature_geometry)
    {
        this.o_geojson_feature_geometry = o_geojson_feature_geometry;
    },
    f_get_geometry: function()
    {
        return this.o_geojson_feature_geometry;
    },
    /**
     * @description Only converts to compatible types, ex: multipolygon to polygon
     * @param {*} s_db_geometry_type 
     * @returns 
     */
    f_get_geometry_as_geometry_of_type: function(s_db_geometry_type)
    {
        let o_geojson_feature_geometry = this.o_geojson_feature_geometry;
        
        if( NSDataTypes.f_geometry_type_is_generic(s_db_geometry_type) )
        {
            return o_geojson_feature_geometry;
        }
        else if( NSDataTypes.f_geometry_type_is_point(s_db_geometry_type) )
        {
            if ( !NSGeoJson.Types.f_is_point( o_geojson_feature_geometry.type ) ) 
            { return null };

            return o_geojson_feature_geometry;
        }
        else if( NSDataTypes.f_geometry_type_is_polyline(s_db_geometry_type))
        {
            if ( !NSGeoJson.Types.f_is_polyline( o_geojson_feature_geometry.type ) 
            //  && !NSGeoJson.Types.f_is_multipolyline( o_geojson_feature_geometry.type )
            ) { return null };

            return o_geojson_feature_geometry;
            
        }
        else if ( NSDataTypes.f_geometry_type_is_polygon(s_db_geometry_type)
                    || NSDataTypes.f_geometry_type_is_multipolygon(s_db_geometry_type)
        )
        {
            
            if ( !NSGeoJson.Types.f_is_polygon( o_geojson_feature_geometry.type ) 
              && !NSGeoJson.Types.f_is_multipolygon( o_geojson_feature_geometry.type )
            ) { return null };

            //desired geometry type is a simple polygon and not a multipolygon
            if( !NSDataTypes.f_geometry_type_is_multipolygon(s_db_geometry_type) 
                && NSDataTypes.f_geometry_type_is_polygon(s_db_geometry_type) )
            {
                if( NSGeoJson.Types.f_is_polygon( o_geojson_feature_geometry.type ) )
                {
                    return o_geojson_feature_geometry;
                }
                else //if ( NSGeoJson.Types.f_is_multipolygon( o_geojson_feature_geometry.type ) )
                {
                    let o_geojson_feature_geometry_polygon = NSGeoJson.f_get_geojson_feature_geometry_of_type_polygon_from_multipolygon(o_geojson_feature_geometry);
                    return o_geojson_feature_geometry_polygon;
                }
            }
            //desired geometry type is multipolygon
            else //if (NSDataTypes.f_geometry_type_is_multipolygon(s_db_geometry_type) )
            {
                if( NSGeoJson.Types.f_is_polygon( o_geojson_feature_geometry.type ) )
                {
                    let o_geojson_feature_geometry_multipolygon = NSGeoJson.f_get_geojson_feature_geometry_of_type_multipolygon_from_polygon(o_geojson_feature_geometry);
                    return o_geojson_feature_geometry_multipolygon;
                }
                else //if ( NSGeoJson.Types.f_is_multipolygon( o_geojson_feature_geometry.type ) )
                {
                    return o_geojson_feature_geometry;
                }
            }
        }
        //return this.o_geojson_feature_geometry;
        return null;

    },
    f_b_clipboard_geometry_exists_and_is_compatible_with_specified_db_geometry_type: function(s_db_geometry_type)
    {
        let o_geojson_feature_geometry = this.o_geojson_feature_geometry;

        if(o_geojson_feature_geometry == null)
            return false;

        
        if(NSDataTypes.f_geometry_type_is_generic(s_db_geometry_type))
        {
            return true;
        }
        else if(NSDataTypes.f_geometry_type_is_point(s_db_geometry_type))
        {
            return NSGeoJson.Types.f_is_point( o_geojson_feature_geometry.type );
        }
        else if(NSDataTypes.f_geometry_type_is_polyline(s_db_geometry_type))
        {
            return NSGeoJson.Types.f_is_polyline( o_geojson_feature_geometry.type )
            //  || NSGeoJson.Types.f_is_multipolyline( o_geojson_feature_geometry.type )
            ;
            
        }
        else //if (NSDataTypes.f_geometry_type_is_polygon(s_db_geometry_type))
        {
            /* doesn't work because openlayers, when starts to draw a new polygon destroys empty multipolygon and returns a polygon
            if(o_geojson_feature_geometry == null
                && NSDataTypes.f_geometry_type_is_multipolygon(s_db_geometry_type))
            {
                o_geojson_feature_geometry = NSGeoJson.f_get_empty_geojson_feature_geometry_of_type_multipolygon();
            }
            */
        
            return NSGeoJson.Types.f_is_polygon( o_geojson_feature_geometry.type )
                || NSGeoJson.Types.f_is_multipolygon( o_geojson_feature_geometry.type )
            ;

        }

    }

}